/* ─── Hidden Messages ─── */

export interface HiddenMessage {
  id: string;
  username: string;
  avatarLetter: string;
  messagePreview: string;
  fullMessage: string;
  hiddenAt: string;
  hiddenBy: string;
  reason: string;
  autoDetected: boolean;
}

export interface ReportedMessage {
  id: string;
  username: string;
  avatarLetter: string;
  messagePreview: string;
  fullMessage: string;
  reportCount: number;
  reportedByUsers: string[];
  lastReportedAt: string;
  status: 'pendiente' | 'revisado' | 'desestimado';
  autoLabel: 'Saludo' | 'Pregunta' | 'Canción' | 'Concurso' | 'Ofensivo' | 'Spam' | 'General';
  programContext: string;
}

export interface SensitivityConfig {
  level: 'bajo' | 'medio' | 'alto' | 'maximo';
  threshold: number;
  autoHide: boolean;
  notifyAdmin: boolean;
}

/* ─── Mock Data ─── */

export const sensitivityDefaults: SensitivityConfig = {
  level: 'medio',
  threshold: 65,
  autoHide: true,
  notifyAdmin: true,
};

export const hiddenMessages: HiddenMessage[] = [
  {
    id: 'hid-1',
    username: 'RockeroTico23',
    avatarLetter: 'R',
    messagePreview: 'Me cago en todo lo que se mueva en esta radio de mi****',
    fullMessage: 'Me cago en todo lo que se mueva en esta radio de mi****. No ponen ni una canción decente, puro reguetón barato. Son una vergüenza.',
    hiddenAt: '2026-06-08T10:15:00Z',
    hiddenBy: 'Sistema',
    reason: 'Filtro automático: múltiples palabras graves detectadas',
    autoDetected: true,
  },
  {
    id: 'hid-2',
    username: 'Anonimo_506',
    avatarLetter: 'A',
    messagePreview: 'Este locutor es un im***** total, no sabe ni lo que dice',
    fullMessage: 'Este locutor es un imbécil total, no sabe ni lo que dice al aire. Deberían despedirlo ya mismo, es una vergüenza para la radio.',
    hiddenAt: '2026-06-08T09:42:00Z',
    hiddenBy: 'Sistema',
    reason: 'Filtro automático: palabra media detectada',
    autoDetected: true,
  },
  {
    id: 'hid-3',
    username: 'TrollMaestro_CR',
    avatarLetter: 'T',
    messagePreview: 'Todos los que escuchan esta radio son unos p**** idiotas',
    fullMessage: 'Todos los que escuchan esta radio son unos p**** idiotas que no tienen criterio musical. Solo ponen basura comercial.',
    hiddenAt: '2026-06-07T22:30:00Z',
    hiddenBy: 'Carlos Mendoza',
    reason: 'Ocultado manualmente: insultos a la audiencia',
    autoDetected: false,
  },
  {
    id: 'hid-4',
    username: 'MusicaFan88',
    avatarLetter: 'M',
    messagePreview: 'click aqui para ganar un iPhone gratis ▶️ bit.ly/falso-link',
    fullMessage: 'click aqui para ganar un iPhone gratis ▶️ bit.ly/falso-link 🔥🔥 aprovechen antes que se acabe!!!',
    hiddenAt: '2026-06-07T18:05:00Z',
    hiddenBy: 'Sistema',
    reason: 'Filtro automático: link sospechoso detectado',
    autoDetected: true,
  },
  {
    id: 'hid-5',
    username: 'DJ_Fake_99',
    avatarLetter: 'D',
    messagePreview: 'ESCUCHEN MI RADIO EN VIVO ES MUCHO MEJOR QUE ESTA BASURA ▶️',
    fullMessage: 'ESCUCHEN MI RADIO EN VIVO ES MUCHO MEJOR QUE ESTA BASURA ▶️ midjradio.com/envivo VENGAN TODOS LOS QUE QUIERAN MÚSICA DE VERDAD',
    hiddenAt: '2026-06-07T15:20:00Z',
    hiddenBy: 'Diego Ramírez',
    reason: 'Ocultado manualmente: autopromoción de radio competidora',
    autoDetected: false,
  },
  {
    id: 'hid-6',
    username: 'HaterNocturno',
    avatarLetter: 'H',
    messagePreview: 'Ojalá se les queme la consola, radio de cuarta categoría',
    fullMessage: 'Ojalá se les queme la consola, radio de cuarta categoría. No merecen ni estar al aire.',
    hiddenAt: '2026-06-07T01:15:00Z',
    hiddenBy: 'Sistema',
    reason: 'Filtro automático: contenido agresivo detectado',
    autoDetected: true,
  },
  {
    id: 'hid-7',
    username: 'SpamBot506',
    avatarLetter: 'S',
    messagePreview: 'GANE DINERO FACIL DESDE CASA 💰💰💰 whatsapp.com/numero-falso',
    fullMessage: 'GANE DINERO FACIL DESDE CASA 💰💰💰 whatsapp.com/numero-falso TRABAJE 2 HORAS AL DIA Y GANE $500 SEMANALES',
    hiddenAt: '2026-06-06T14:30:00Z',
    hiddenBy: 'Sistema',
    reason: 'Filtro automático: spam y link externo detectado',
    autoDetected: true,
  },
  {
    id: 'hid-8',
    username: 'CriticoMusical',
    avatarLetter: 'C',
    messagePreview: 'La canción que pusieron es una completa basura, cero talento',
    fullMessage: 'La canción que pusieron es una completa basura, cero talento el artista ese. Pongan algo con calidad por favor.',
    hiddenAt: '2026-06-06T11:00:00Z',
    hiddenBy: 'María Solís',
    reason: 'Ocultado manualmente: lenguaje despectivo hacia artistas',
    autoDetected: false,
  },
  {
    id: 'hid-9',
    username: 'RadioLover506',
    avatarLetter: 'R',
    messagePreview: 'ESTO ES UN ASALTO A LA BUENA MÚSICA PONGAN ALGO DECENTE',
    fullMessage: 'ESTO ES UN ASALTO A LA BUENA MÚSICA PONGAN ALGO DECENTE POR FAVOR YA ME TIENEN HARTO CON TANTA REPETICIÓN',
    hiddenAt: '2026-06-05T20:45:00Z',
    hiddenBy: 'Sistema',
    reason: 'Filtro automático: mayúsculas excesivas (83% del mensaje)',
    autoDetected: true,
  },
  {
    id: 'hid-10',
    username: 'ElSarcasticoCR',
    avatarLetter: 'E',
    messagePreview: 'Qué programa tan "interesante"... si les gusta escuchar a alguien que no sabe ni hablar',
    fullMessage: 'Qué programa tan "interesante"... si les gusta escuchar a alguien que no sabe ni hablar. La locutora parece que está leyendo por primera vez.',
    hiddenAt: '2026-06-05T09:30:00Z',
    hiddenBy: 'Diego Ramírez',
    reason: 'Ocultado manualmente: comentario despectivo hacia locutora',
    autoDetected: false,
  },
];

export const reportedMessages: ReportedMessage[] = [
  {
    id: 'rep-1',
    username: 'Polemico506',
    avatarLetter: 'P',
    messagePreview: 'Todos los ticos son unos vagos que no hacen nada productivo',
    fullMessage: 'Todos los ticos son unos vagos que no hacen nada productivo, solo saben quejarse y pedir regalías del gobierno.',
    reportCount: 8,
    reportedByUsers: ['OyenteFiel23', 'MaríaCR', 'JuanPerez506', 'RadioFan99', 'TicaOrgullosa', 'SofiaMúsica', 'DJ_Cartago', 'LocutorFan'],
    lastReportedAt: '2026-06-08T08:30:00Z',
    status: 'pendiente',
    autoLabel: 'Ofensivo',
    programContext: 'Mañanas Latinas',
  },
  {
    id: 'rep-2',
    username: 'VendeHumo_CR',
    avatarLetter: 'V',
    messagePreview: 'Compro votos para el concurso de la radio, $5 por voto, whatsapp al 8888-7777',
    fullMessage: 'Compro votos para el concurso de la radio, $5 por voto confirmado, whatsapp al 8888-7777. Seriedad garantizada.',
    reportCount: 5,
    reportedByUsers: ['ConcursanteReal', 'FanRadio506', 'AnonimoTico', 'LocutorNatalia', 'ProductorDiego'],
    lastReportedAt: '2026-06-08T07:15:00Z',
    status: 'pendiente',
    autoLabel: 'Concurso',
    programContext: 'Tardes de Pop - Concurso',
  },
  {
    id: 'rep-3',
    username: 'DJ_Shady_Real',
    avatarLetter: 'D',
    messagePreview: 'Esa Natalia Vargas se cree mucho, solo está ahí porque es bonita',
    fullMessage: 'Esa Natalia Vargas se cree mucho, solo está ahí porque es bonita. De locución no sabe nada, yo haría mejor trabajo.',
    reportCount: 4,
    reportedByUsers: ['FanNatalia', 'DefensorCR', 'RadioEscucha', 'TeamVargas'],
    lastReportedAt: '2026-06-07T21:00:00Z',
    status: 'pendiente',
    autoLabel: 'Ofensivo',
    programContext: 'Tardes de Pop',
  },
  {
    id: 'rep-4',
    username: 'RadioHater99',
    avatarLetter: 'R',
    messagePreview: 'Esta radio es un chiste, puros anuncios y cero contenido real',
    fullMessage: 'Esta radio es un chiste, puros anuncios y cero contenido real. Deberían cerrar y dejar el dial libre para alguien que sí sepa.',
    reportCount: 3,
    reportedByUsers: ['Leal506', 'OyenteDiario', 'FanDesde2010'],
    lastReportedAt: '2026-06-07T16:45:00Z',
    status: 'revisado',
    autoLabel: 'General',
    programContext: 'Noches de Rock',
  },
  {
    id: 'rep-5',
    username: 'Conspirador_TV',
    avatarLetter: 'C',
    messagePreview: 'El gobierno controla las radios, nos están lavando el cerebro con música',
    fullMessage: 'El gobierno controla todas las radios del país, nos están lavando el cerebro con la música que programan. Despierten, borregos.',
    reportCount: 6,
    reportedByUsers: ['Razonable506', 'MusicoIndependiente', 'TicaNormal', 'RadioLibreCR', 'EscépticoSJ', 'AndreaMúsica'],
    lastReportedAt: '2026-06-07T14:20:00Z',
    status: 'pendiente',
    autoLabel: 'General',
    programContext: 'Mañanas Latinas',
  },
  {
    id: 'rep-6',
    username: 'AcosadorMusical',
    avatarLetter: 'A',
    messagePreview: 'Natalia te amo, sos la mujer más hermosa del mundo, casate conmigo',
    fullMessage: 'Natalia te amo, sos la mujer más hermosa del mundo, casate conmigo por favor. Te escribo todos los días y nunca me contestás. Estoy enamorado de tu voz.',
    reportCount: 7,
    reportedByUsers: ['ModeradorCR', 'OyentePreocupada', 'FanRespetuoso', 'AdminRadio', 'Seguridad506', 'LocutorCarlos', 'ProductorMaría'],
    lastReportedAt: '2026-06-07T09:00:00Z',
    status: 'pendiente',
    autoLabel: 'Ofensivo',
    programContext: 'Tardes de Pop',
  },
  {
    id: 'rep-7',
    username: 'SpamKing506',
    avatarLetter: 'S',
    messagePreview: '🔥 OFERTA IMPERDIBLE 🔥 Audífonos Beats 90% descuento solo hoy link abajo',
    fullMessage: '🔥 OFERTA IMPERDIBLE 🔥 Audífonos Beats 90% descuento solo hoy link abajo ▶️ tiendafalsa-cr.com/oferta 🔥 SOLO POR HOY NO TE LO PIERDAS 🔥',
    reportCount: 4,
    reportedByUsers: ['AlertaSpam', 'OyenteVigilante', 'Mod506', 'AntiFraudeCR'],
    lastReportedAt: '2026-06-06T19:30:00Z',
    status: 'revisado',
    autoLabel: 'Spam',
    programContext: 'Noches de Rock',
  },
  {
    id: 'rep-8',
    username: 'ElPeleon506',
    avatarLetter: 'E',
    messagePreview: 'Callate Carlos Mendoza sos un vendido, solo ponés lo que te pagan',
    fullMessage: 'Callate Carlos Mendoza sos un vendido, solo ponés lo que te pagan las disqueras. No tenés criterio propio, sos un títere de la industria.',
    reportCount: 3,
    reportedByUsers: ['DefensorMendoza', 'OyenteFiel', 'CriterioMusical'],
    lastReportedAt: '2026-06-06T15:00:00Z',
    status: 'pendiente',
    autoLabel: 'Ofensivo',
    programContext: 'Especial Sábado',
  },
  {
    id: 'rep-9',
    username: 'LenguaSueltaCR',
    avatarLetter: 'L',
    messagePreview: 'En el bar de la esquina de la radio venden droga, todos saben y nadie dice nada',
    fullMessage: 'En el bar de la esquina de la radio venden droga, todos saben y nadie dice nada. La policía está comprada.',
    reportCount: 5,
    reportedByUsers: ['VecinoPreocupado', 'ComercianteLocal', 'RadioEscucha506', 'CiudadanoCR', 'AlertaSJ'],
    lastReportedAt: '2026-06-06T11:45:00Z',
    status: 'pendiente',
    autoLabel: 'General',
    programContext: 'Mañanas Latinas',
  },
  {
    id: 'rep-10',
    username: 'FanaticoExtremo',
    avatarLetter: 'F',
    messagePreview: 'SI NO PONEN A BAD BUNNY AHORA MISMO VOY A IR A LA RADIO',
    fullMessage: 'SI NO PONEN A BAD BUNNY AHORA MISMO VOY A IR A LA RADIO Y VOY A ARMAR UN ESCÁNDALO. YA LES HE PEDIDO 20 VECES Y ME IGNORAN.',
    reportCount: 3,
    reportedByUsers: ['Tranquilo506', 'PazYAmorCR', 'SeguridadRadio'],
    lastReportedAt: '2026-06-06T08:15:00Z',
    status: 'revisado',
    autoLabel: 'Pregunta',
    programContext: 'Tardes de Pop',
  },
];

export const statusLabels: Record<ReportedMessage['status'], string> = {
  pendiente: 'Pendiente',
  revisado: 'Revisado',
  desestimado: 'Desestimado',
};

export const statusColors: Record<ReportedMessage['status'], string> = {
  pendiente: 'bg-red-100 text-red-700',
  revisado: 'bg-amber-100 text-amber-700',
  desestimado: 'bg-foreground-200 text-foreground-600',
};

export const sensitivityLevels: { value: SensitivityConfig['level']; label: string; desc: string }[] = [
  { value: 'bajo', label: 'Bajo', desc: 'Solo bloquea las palabras más graves. Mínima intervención.' },
  { value: 'medio', label: 'Medio', desc: 'Equilibrio entre protección y libertad de expresión.' },
  { value: 'alto', label: 'Alto', desc: 'Filtrado más estricto. Mayor cantidad de mensajes en revisión.' },
  { value: 'maximo', label: 'Máximo', desc: 'Máxima protección. Todos los mensajes pasan por revisión.' },
];